import type { Order } from '../models/order';
import { resolveFirestoreDate } from './format';

/**
 * Primary: created desc (business date).
 * Tie-break: saleNumber desc so same-timestamp rows (e.g. legacy noon stamps) stay ordered.
 */
export function sortOrdersByCreatedThenSaleNumber(orders: Order[]): Order[] {
  return [...orders].sort((a, b) => {
    const aCreated = resolveFirestoreDate(a.created)?.getTime() ?? 0;
    const bCreated = resolveFirestoreDate(b.created)?.getTime() ?? 0;
    if (aCreated !== bCreated) {
      return bCreated - aCreated;
    }
    const aNum = Number(a.saleNumber) || 0;
    const bNum = Number(b.saleNumber) || 0;
    return bNum - aNum;
  });
}
